export default "__VITE_ASSET__27d6891a__"